export async function shareFileDownloadAxios(id) {
    return await api.get("filesharings/download/" + id);
}